export default import.meta.ROLLDOWN_FILE_URL_UpadcW8tBWqxKusCNme73w